<template>
  <categories-selection-popup title="הוספת קטגוריה למעקב" :categoriesOptions="availableTrackingCategories" :onClose="close" @done-clicked="onSave">
    <template v-slot:sub-title>
      <div class="question">לאיזה קטגוריית הוצאות תרצו להגדיר יעד חודשי בתזרים?</div>
    </template>
  </categories-selection-popup>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import * as _ from 'lodash';
import Segment from '../../../../../../../../../../Segment';
import cashflowViewConsts from '../../../../../../../../../../constants/cashflow-view';
import CategoriesSelectionPopup from '../../CategoriesSelectionPopup';

export default {
  name: 'CreateTrackingCategoryPopup',
  components: {
    CategoriesSelectionPopup,
  },
  created() {
    this.selectTrackingCategory(_.first(this.availableTrackingCategories));
    Segment.trackUserInteraction('CreateTrackingCategory_Entered', {});
  },
  computed: {
    ...mapState('createTrackingCategory', ['selectedTrackingCategory', 'isCustomTrackingCategory']),
    ...mapGetters('createTrackingCategory', ['availableTrackingCategories', 'customCategoryLabel']),
    ...mapGetters('cashflowView', ['presentedBudget']),
    variant() {
      return cashflowViewConsts.CATEGORY_STYLE[cashflowViewConsts.CASHFLOW_CATEGORIES.TRACKING];
    },
  },
  methods: {
    ...mapActions('createTrackingCategory', ['selectTrackingCategory', 'selectTrackingCategory']),
    close() {
      Segment.trackUserInteraction('CreateTrackingCategory_CloseClicked', {});
      this.$emit('close');
    },
    onSave() {
      Segment.trackUserInteraction('CreateTrackingCategory_SaveClicked', {
        selectedTrackingCategory: this.selectedTrackingCategory,
        availableTrackingCategories: this.availableTrackingCategories,
      });
      this.$emit('done-clicked');
    },
  },
};
</script>

<style lang="scss">

</style>
